export const amenitiesFormatter = (isParkingSpaceInAmenities: boolean = false): string => {
  if (isParkingSpaceInAmenities) {
    return ` (含車位)`;
  }
  return '';
};
